export default __webpack_public_path__ + "static/media/softwaremant.b29e1931.jpg";